import React from "react";
import "./header.css";
import CTA from "./CTA";
import ME from '../../assets/me-about.jpg'
import HeaderSocials from "./HeaderSocials";
import {AiOutlineArrowRight} from "react-icons/ai";

const Header = () => {
  return (
    <header id="home">
      <div className="container header__container">
        <h5>Hey there! I'm</h5>
        <h1>Ankit Basare</h1>
        <h4 className="text-light">Full Stack Developer</h4>
        <h5 className="text-light header__text">
          I like to build REST APIs, web applications, and data-driven platforms with Node.js, React, and Python. <br />
          Mumbai | Pune | Bangalore
        </h5>
        <div className="me">
          <img src={ME} alt="me" />
        </div>
        <CTA />
        <HeaderSocials />

        <a href="#contact" className="scroll__down">
          <AiOutlineArrowRight />
        </a>
      </div>
    </header>
  );
};

export default Header;
